require("-!/app/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!style-loader!css-loader!less-loader!/app/node_modules/font-awesome-webpack/font-awesome-styles.loader.js!/app/src/theme/font-awesome.config.prod.js");


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-webpack/index.loader.js!./src/theme/font-awesome.config.prod.js
// module id = 957
// module chunks = 0